import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import SpecialOffersTableFilters from "components/subComponents/SpecialOffersTableFilters";

import useSpecialOffersList from "hooks/list/useSpecialOffersList";

function ElencoOfferteSpeciali() {
    const specialOffersListHook = useSpecialOffersList();

    const { navigateToNewSpecialOffer, alertConfirmHook, dataTableHook } = specialOffersListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <SpecialOffersTableFilters specialOffersListHook={specialOffersListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewSpecialOffer}>
                        Nuova offerta speciale
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoOfferteSpeciali;
